import axios from 'axios'

const LOCAL_URL = process.env.REACT_APP_LOCALHOST
const API_TOKEN = localStorage.getItem('api_token') || ''

export const GET_DASHBOARD_DATA = `${LOCAL_URL}/dashboard`
export const GET_REVENUE_DATA = `${LOCAL_URL}/dashboardDetails2`

const headers = {
  Authorization: API_TOKEN,
  //'Authorization': `eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhY291bnRfaWQiOjF9.vQulc2UJUYmHkVDdIxiqFGiIgtv82WGun4CRzzNbzXo`
}

// function to get property type
export async function getDashboardData() {
  const headers = {
    Authorization: API_TOKEN
  }
  return await axios.get(
    GET_DASHBOARD_DATA,
    {
      headers
    }
  )
}

//function to get revenue details

export async function getRevenueDetails() {
  const headers = {
    Authorization: API_TOKEN
  }
  return await axios.get(
    GET_REVENUE_DATA,
    {
      headers
    }
  )
}